import { H2, SubtitleM, GRAY50 } from 'global-styles';
import styled, { css } from 'styled-components';
import techFirstImg from 'public/asset/about/02-section2/section2-img-1.png';
import techSecondImg from 'public/asset/about/02-section2/section2-img-2.png';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { txtAnimation } from 'components/Home/BannerItems';
import { opacityAppear } from 'components/Home/ProductTemplate';
import Image from 'next/image';

const KoTextFirst = () => (
  <>
    <div className="anim-wrapper">
      <SubtitleM>
        비디오에 특화된 인공지능 모델을 개발하여 CPU와 GPU 같은 범­용 컴퓨팅
        장치를 활­용하는 소프트웨어 솔루션 대신, 프로그래머블 FPGA 프로세서에
        시스템 반도체 설계 기술로 솔루션을 구현함으로써 같은 비용으로 더 많은
        고화질 동영상 처리 작업을 할 수 있습니다.
      </SubtitleM>
      <br />
      <br />
      <br />
      <br />
      <SubtitleM>
        API 그리고 FFmpeg 미디어 프레임워크를 지원하기 때문에 반도체의 지식이
        없이도 쉽게 솔루션을 사용할 수 있습니다.
      </SubtitleM>
    </div>
  </>
);
const KoTextSecond = () => (
  <>
    <SubtitleM>
      <div className="anim-wrapper">
        영상압축 반도체 IP 분야에서 20년 이상의 R&D와 제품기획 경험을 갖춘
        전문가들이 블루닷을 창업하였습니다. 그리고, 인공지능 알고리즘과 반도체
        IP를 개발해 온 열정과 창의성 넘치는 젊은 개발자들이 함께 하고 있습니다.
      </div>
    </SubtitleM>
  </>
);
const EnTextFirst = () => (
  <>
    <SubtitleM>
      <div className="anim-wrapper">
        By developing AI model specialized for video applications and
        implementing it with Semiconductor Design technology on a programmable
        FPGA processor, more High Quality video processing tasks can be
        performed at the same cost compared to software solutions that utilize
        general-purpose computing devices such as CPU and GPU.
      </div>
    </SubtitleM>
  </>
);
const EnTextSecond = () => (
  <>
    <SubtitleM>
      <div className="anim-wrapper">
        BLUEDOT was founded, a company of experts with more than 20 years of
        experience in planning products with R&D in Semiconductor IP field of
        Video Codec. And we are working with young developers full of passion
        and creativity in the development of Semiconductor IPs and Deep Learning
        Algorithms.
      </div>
    </SubtitleM>
  </>
);

interface Props {
  isVisible: boolean;
  // targetRef: MutableRefObject<HTMLElement>;
  targetRef: (node?: Element) => void;
}

export const Technology = ({ isVisible, targetRef }: Props) => {
  const { locale } = useRouter();

  const techArray = useMemo(
    () => [
      {
        imgSrc: techFirstImg.src,
        alt: '',
        textComponent: locale === 'en' ? <EnTextFirst /> : <KoTextFirst />,
      },
      {
        imgSrc: techSecondImg.src,
        alt: '',
        textComponent: locale === 'en' ? <EnTextSecond /> : <KoTextSecond />,
      },
    ],
    [locale]
  );

  return (
    <TechnologyContainer ref={targetRef} isVisible={isVisible}>
      <H2 className="tech-title">Our Technology</H2>
      <div className="tech-inner-container">
        {techArray.map(tech => (
          <div className="tech-content-wrapper" key={tech.imgSrc}>
            <div className="tech-content-left">
              <div className="tech-img-wrapper">
                <Image
                  className="tech-img"
                  src={tech.imgSrc}
                  quality={80}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <div className="tech-content-right">{tech.textComponent}</div>
          </div>
        ))}
      </div>
    </TechnologyContainer>
  );
};

const TechnologyContainer = styled.section`
  @media screen and (min-width: 1440px) {
    width: 100%;
    max-width: 1200px;
    margin: 192px auto 146px;
  }
  @media screen and (min-width: 1240px) and (max-width: 1439px) {
    width: calc(100% - 192px);
    margin: 192px 96px 146px;
  }
  @media screen and (min-width: 905px) and (max-width: 1239px) {
    width: calc(100% - 112px);
    margin: 146px 56px 96px;
  }
  @media screen and (min-width: 600px) and (max-width: 904px) {
    width: calc(100% - 64px);
    margin: 96px 32px 56px;
  }
  @media screen and (max-width: 599px) {
    width: calc(100% - 32px);
    margin: 56px 16px 32px;
  }
  .tech-title {
    opacity: 0;
    text-align: center;
    margin-bottom: 56px;
    @media screen and (max-width: 1239px) and (min-width: 905px) {
      margin-bottom: 32px;
    }
    @media screen and (max-width: 904px) {
      margin-bottom: 16px;
    }
  }
  .tech-inner-container {
    width: 100%;
  }
  .tech-content-wrapper {
    display: flex;
  }
  .tech-content-wrapper + .tech-content-wrapper {
    margin-top: 56px;
  }
  .tech-content-left {
    opacity: 0;
  }
  .tech-content-left,
  .tech-content-right {
    width: 50%;
    overflow-y: hidden;
    .anim-wrapper {
      opacity: 0;
    }
    .tech-img-wrapper {
      width: 100%;
      position: relative;
      .tech-img {
        object-fit: contain;
        position: relative !important;
        width: 100% !important;
        height: unset !important;
      }
    }
    .tech-img-wrapper > span {
      position: unset !important;
    }
  }
  .tech-content-right {
    padding-left: 56px;
    align-self: center;
    color: ${GRAY50};
    overflow-y: hidden;
  }
  @media screen and (max-width: 1239px) {
    .tech-content-wrapper {
      flex-wrap: wrap;
      justify-content: center;
    }
    .tech-content-left,
    .tech-content-right {
      flex-wrap: wrap;
      flex-shrink: 0;
      width: 100%;
      max-width: 800px;
    }
    .tech-content-left {
      display: flex;
    }
    .tech-content-right {
      padding-left: 0;
      padding-top: 16px;
    }
  }
  @media screen and (max-width: 904px) {
    .tech-content-left,
    .tech-content-right {
      width: 100%;
    }
  }

  ${({ isVisible }: { isVisible: boolean }) =>
    isVisible &&
    css`
      .tech-title {
        animation: ${txtAnimation} 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
      }
      .tech-content-left {
        animation: ${opacityAppear} 0.8s 0.2s cubic-bezier(0.4, 0, 0.2, 1)
          forwards;
      }
      .tech-content-right {
        .anim-wrapper {
          animation: ${txtAnimation} 1.2s 0.4s cubic-bezier(0.4, 0, 0.2, 1)
            forwards;
        }
      }
    `};
`;
